import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { SnackbarService } from '@shared/snack-bar/snack-bar.service';
import { parseError } from '@state/errors.parser';
import * as uscActions from './user-supporting-company.actions';
import { UserSupportingCompanyHttpService } from '@core/http/user-supporting-company.http.service';

@Injectable()
export class UserSupportingCompanyEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly uscHttp: UserSupportingCompanyHttpService,
    private readonly snackService: SnackbarService
  ) {}

  getCompaniesSupportedByUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uscActions.getCompaniesSupportedByUser),
      switchMap(({ userId }) => {
        return this.uscHttp.getCompaniesSupportedByUser(userId).pipe(
          map(companiesSupportedByUser => uscActions.getCompaniesSupportedByUserSuccess({ companiesSupportedByUser })),
          catchError(error => {
            const errorMessage = parseError(error, uscActions.getCompaniesSupportedByUser.type);
            this.snackService.showError('MANAGEMENT.EMPLOYEE_DETAILS.ERROR_FETCHING_LIST_OF_SUPPORTING_COMPANIES');
            return of(uscActions.getCompaniesSupportedByUserError({ errorMessage }));
          })
        );
      })
    )
  );

  getUsersSupportingCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uscActions.getUsersSupportingCompany),
      switchMap(({ companyId }) => {
        return this.uscHttp.getUsersSupportingCompany(companyId).pipe(
          map(usersSupportingCompany => uscActions.getUsersSupportingCompanySuccess({ usersSupportingCompany })),
          catchError(error => {
            const errorMessage = parseError(error, uscActions.getUsersSupportingCompany.type);
            this.snackService.showError('MANAGEMENT.COMPANY_DETAILS.ERROR_FETCHING_LIST_OF_SUPPORTING_EMPLOYEES');
            return of(uscActions.getUsersSupportingCompanyError({ errorMessage }));
          })
        );
      })
    )
  );

  updateSupportingCompanyOfUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uscActions.updateSupportingCompanyOfUser),
      switchMap(({ opts }) => {
        return this.uscHttp.updateSupportingCompanyOfUser(opts).pipe(
          map(userSupportingCompany => uscActions.updateSupportingCompanyOfUserSuccess({ userSupportingCompany })),
          catchError(error => {
            const errorMessage = parseError(error, uscActions.updateSupportingCompanyOfUser.type);
            this.snackService.showError('MANAGEMENT.ERROR_UPDATING_SUPPORTED_COMPANY');
            return of(uscActions.updateSupportingCompanyOfUserError({ errorMessage }));
          })
        );
      })
    )
  );
}
